import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class HourlyBonusResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("HourlyBonusResourcePackage");
    }
    public get assets_views_hourly_bonus_hourly_bonus_0_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/hourly_bonus/hourly_bonus-0_1x.atlas.json");
    }
    public get assets_views_hourly_bonus_golden_wheel_night_bg_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_0_1x_atlas_json.textures["golden_wheel/night_bg.png"];
    }
    public get assets_views_hourly_bonus_wheel_popup_bg_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_0_1x_atlas_json.textures["wheel_popup_bg.png"];
    }
    public get assets_views_hourly_bonus_golden_wheel_bg_light_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_0_1x_atlas_json.textures["golden_wheel/bg_light.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_base_bg_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_0_1x_atlas_json.textures["hourly_bonus/base_bg.png"];
    }
    public get assets_views_hourly_bonus_wheel_center_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_0_1x_atlas_json.textures["wheel_center.png"];
    }
    public get assets_views_hourly_bonus_wheel_light_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_0_1x_atlas_json.textures["wheel_light.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_waiting_middle_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_0_1x_atlas_json.textures["hourly_bonus/waiting_middle.png"];
    }
    public get assets_views_hourly_bonus_piggy_wheel_toke_coin_icon_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_0_1x_atlas_json.textures["piggy_wheel/toke_coin_icon.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_0_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/hourly_bonus/hourly_bonus-0_1x.atlas.png");
    }
    public get assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/hourly_bonus/hourly_bonus-1_1x.atlas.json");
    }
    public get assets_views_hourly_bonus_hourly_bonus_ready_bg_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["hourly_bonus/ready_bg.png"];
    }
    public get assets_views_hourly_bonus_piggy_wheel_piggy_wheel_glow_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["piggy_wheel/piggy_wheel_glow.png"];
    }
    public get assets_views_hourly_bonus_button_bg_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["button_bg.png"];
    }
    public get assets_views_hourly_bonus_golden_wheel_wheel_glow_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["golden_wheel/wheel_glow.png"];
    }
    public get assets_views_hourly_bonus_opssss_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["opssss.png"];
    }
    public get assets_views_hourly_bonus_piggy_wheel_piggy_wheel_light_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["piggy_wheel/piggy_wheel_light.png"];
    }
    public get assets_views_hourly_bonus_golden_wheel_light_yellow_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["golden_wheel/light_yellow.png"];
    }
    public get assets_views_hourly_bonus_golden_wheel_bg_for_x_more_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["golden_wheel/bg_for_x_more.png"];
    }
    public get assets_views_hourly_bonus_piggy_wheel_piggy_wheel_sector_bg_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["piggy_wheel/piggy_wheel_sector_bg.png"];
    }
    public get assets_views_hourly_bonus_wheel_result_dice_04_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["wheel_result/dice_04.png"];
    }
    public get assets_views_hourly_bonus_golden_wheel_wheel_button_red_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["golden_wheel/wheel_button_red.png"];
    }
    public get assets_views_hourly_bonus_wheel_button_green_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["wheel_button_green.png"];
    }
    public get assets_views_hourly_bonus_wheel_result_dice_01_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["wheel_result/dice_01.png"];
    }
    public get assets_views_hourly_bonus_wheel_result_dice_03_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["wheel_result/dice_03.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_complete_midle_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["hourly_bonus/complete_midle.png"];
    }
    public get assets_views_hourly_bonus_dice_2_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["dice_2.png"];
    }
    public get assets_views_hourly_bonus_wheel_result_dice_02_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["wheel_result/dice_02.png"];
    }
    public get assets_views_hourly_bonus_wheel_result_dice_07_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["wheel_result/dice_07.png"];
    }
    public get assets_views_hourly_bonus_wheel_result_dice_06_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["wheel_result/dice_06.png"];
    }
    public get assets_views_hourly_bonus_dice_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["dice.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_dice_rewards_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_json.textures["hourly_bonus/dice_rewards.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_1_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/hourly_bonus/hourly_bonus-1_1x.atlas.png");
    }
    public get assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/hourly_bonus/hourly_bonus-2_1x.atlas.json");
    }
    public get assets_views_hourly_bonus_golden_wheel_golden_wheel_base_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["golden_wheel/golden_wheel_base.png"];
    }
    public get assets_views_hourly_bonus_piggy_wheel_piggy_wheel_base_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["piggy_wheel/piggy_wheel_base.png"];
    }
    public get assets_views_hourly_bonus_wheel_bg_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["wheel_bg.png"];
    }
    public get assets_views_hourly_bonus_wheel_result_dice_wheel_result_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["wheel_result/dice_wheel_result.png"];
    }
    public get assets_views_hourly_bonus_piggy_wheel_piggy_wheel_center_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["piggy_wheel/piggy_wheel_center.png"];
    }
    public get assets_views_hourly_bonus_golden_wheel_wheel_button_light_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["golden_wheel/wheel_button_light.png"];
    }
    public get assets_views_hourly_bonus_wheel_result_dice_05_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["wheel_result/dice_05.png"];
    }
    public get assets_views_hourly_bonus_golden_wheel_golden_wheel_sector_bg_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["golden_wheel/golden_wheel_sector_bg.png"];
    }
    public get assets_views_hourly_bonus_daily_wheel_gray_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["daily_wheel_gray.png"];
    }
    public get assets_views_hourly_bonus_golden_wheel_wheel_button_gray_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["golden_wheel/wheel_button_gray.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_arrows_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["hourly_bonus/arrows.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_waiting_left_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["hourly_bonus/waiting_left.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_waiting_right_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["hourly_bonus/waiting_right.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_ready_midle_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["hourly_bonus/ready_midle.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_emty_middle_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["hourly_bonus/emty_middle.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_complete_left_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["hourly_bonus/complete_left.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_ready_left_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["hourly_bonus/ready_left.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_empty_right_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["hourly_bonus/empty_right.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_ready_right_png(): Texture {
        return this.assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_json.textures["hourly_bonus/ready_right.png"];
    }
    public get assets_views_hourly_bonus_hourly_bonus_2_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/hourly_bonus/hourly_bonus-2_1x.atlas.png");
    }
}

